import { Divider, Typography } from '@mui/material';
import { type FC, type ReactElement, useContext } from 'react';

import { SlabContext } from '@core/context/SlabContext';
import Enums from '@core/types/api/Enums';
import { FileEntityType } from '@core/types/file';
import { EntityFilesSection, type FileUploadsManager } from '@web/components/Files';

type Props = {
  contactID: string | null;
  manager: FileUploadsManager;
};

export const ContactFilesSection: FC<Props> = ({ contactID, manager }): ReactElement | null => {
  const ctx = useContext(SlabContext);
  const filesFlagEnabled = ctx.userInfo.hasFlags([
    Enums.FeatureFlagName.FeatureFlagFileAttachments,
  ]);

  if (!filesFlagEnabled) {
    return null;
  }

  return (
    <>
      <Divider />
      <Typography variant='h2'>Files</Typography>
      <EntityFilesSection
        entityType={FileEntityType.Contact}
        entityId={contactID}
        manager={manager}
      />
    </>
  );
};
